(function () {
  const ENABLE_SNOW = true;
  const MAX_FLAKES = 35;

  if (!ENABLE_SNOW) return;

  // Avoid showing snow in the Shopify theme editor.
  if (window.Shopify && window.Shopify.designMode) return;

  // Avoid creating the effect twice.
  if (document.getElementById('cortex-snow')) return;

  const style = document.createElement('style');
  style.textContent = `
    #cortex-snow {
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 9999;
      overflow: hidden;
    }

    .cortex-snowflake {
      position: absolute;
      top: -20px;
      color: #fff;
      opacity: 0.75;
      text-shadow: 0 0 4px rgba(0,0,0,0.12);
      user-select: none;
      will-change: transform;
      animation: cortex-snow-fall linear infinite;
    }

    @keyframes cortex-snow-fall {
      0% {
        transform: translate3d(0, -5vh, 0) rotate(0deg);
      }
      100% {
        transform: translate3d(35px, 110vh, 0) rotate(240deg);
      }
    }

    @media (prefers-reduced-motion: reduce) {
      #cortex-snow { display: none; }
    }
  `;
  document.head.appendChild(style);

  const layer = document.createElement('div');
  layer.id = 'cortex-snow';
  layer.setAttribute('aria-hidden', 'true');
  document.body.appendChild(layer);

  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const flakeCount = isMobile ? 18 : MAX_FLAKES;
  const fragment = document.createDocumentFragment();

  for (let i = 0; i < flakeCount; i++) {
    const flake = document.createElement('span');
    flake.className = 'cortex-snowflake';
    flake.textContent = '❄';

    const size = 8 + Math.random() * 10;
    const duration = 9 + Math.random() * 13;

    flake.style.left = Math.random() * 100 + '%';
    flake.style.fontSize = size + 'px';
    flake.style.opacity = (0.25 + Math.random() * 0.5).toFixed(2);
    flake.style.animationDuration = duration + 's';
    flake.style.animationDelay = (-Math.random() * duration) + 's';

    fragment.appendChild(flake);
  }

  layer.appendChild(fragment);
})();